// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__12Nts","header":"PatientQuestionnaire_header__3S8EC","info":"PatientQuestionnaire_info__oyDPN"};